import { Apis } from "../../lib/Apis"

export const useBlog = () => {
    const getBlogCategories = async () => {
        try {
            const response = await Apis.getAllBlogCategories()
            return response.data
        } catch (error) {
            console.error("Error fetching blog categories:", error)
            throw error
        }
    }
    const postBlog = async (data) => {
        try {
            const response = await Apis.postBlog(data)
            return response.data
        } catch (error) {
            console.error("Error posting blog:", error)
        }
    }
    const updateBlog = async (id, data) => {
        try {
            const response = await Apis.updateBlog(id, data)
            return response.data
        } catch (error) {
            console.error("Error updating blog:", error)
            throw error
        }
    }
    const getBlogs = async (paginationParams = {}, searchParams = {}) => {
        try {
            const params = { ...paginationParams, ...searchParams };
            const response = await Apis.getBlogs(params)
            return {
                data: response.data.data.data,
                pagination: response.data.data.pagination
            }
        } catch (error) {
            console.error("Error fetching blogs:", error)
            throw error
        }
    }

    const searchBlogs = async (paginationParams = {}, searchParams = {}) => {
        try {
            const params = { ...paginationParams, ...searchParams };
            const response = await Apis.getBlogs(params);
            return {
                data: response.data.data.data,
                pagination: response.data.data.pagination
            };
        } catch (error) {
            console.error("🚀 ~ file: useHook.js ~ line 64 ~ searchBlogs ~ error", error);
            return error;
        }
    };
    const getBlogById = async (id) => {
        try {
            const response = await Apis.getBlogById(id)
            return response.data.data
        } catch (error) {
            console.error("Error fetching blog by id:", error)
            throw error
        }
    }
    const addPopularBlog = async (data) => {
        try {
            const response = await Apis.addPopularBlog(data)
            return response.data
        } catch (error) {
            console.error("Error adding popular blog:", error)
            throw error
        }
    }
    const addOnHeaderBlog = async (data) => {
        try {
            const response = await Apis.addOnHeaderBlog(data)
            return response.data
        } catch (error) {
            console.error("Error adding on header blog:", error)
            throw error
        }
    }
    const deleteBlog = async (id) => {
        try {
            const response = await Apis.deleteBlog(id)
            return response.data
        } catch (error) {
            console.error("Error deleting blog:", error)
            throw error
        }
    }
    const showBlogOnHomeScreen = async (blogId, homeScreen) => {
        try {
            const data = {
                blogId,
                homeScreen: homeScreen ? 1 : 0
            };
            const response = await Apis.addBlogToHomeScreen(data);
            return response;
        } catch (error) {
            console.error("Error updating home screen status:", error);
            return error;
        }
    };

    const updateBlogPosition = async (blogId, newPosition) => {
        try {
            const response = await Apis.updateBlogPosition({ blogId: Number(blogId), newPosition });
            return response?.data;
        } catch (error) {
            console.error("Error updating blog position:", error);
            throw error;
        }
    };

    return {
        getBlogCategories,
        postBlog,
        updateBlog,
        getBlogs,
        getBlogById,
        addPopularBlog,
        addOnHeaderBlog,
        deleteBlog,
        showBlogOnHomeScreen,
        searchBlogs,
        updateBlogPosition
    }
}
